import { render } from "./perfil.vue?vue&type=template&id=df3feb08&scoped=true&ts=true"
import script from "./perfil.vue?vue&type=script&lang=ts"
export * from "./perfil.vue?vue&type=script&lang=ts"

import "./perfil.vue?vue&type=style&index=0&id=df3feb08&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df3feb08"]])

export default __exports__